import { useMemo } from 'react';
import { useGetEditOrActual } from '../../CampaignSettings/selectors/useGetEditOrActual';

export const useIsSplitTestControlGroupSelector = (id: string) => {
  const state = useGetEditOrActual();

  return useMemo(() => state.splitTests[id]?.controlGroupEnabled, [id, state]);
};
